import React from 'react';
import { TEXT_KEYS } from '../../../constants/textKeys';
import { useIsMobile } from '../../../hooks/useIsMobile';
import IMAGES_PATH from '../../../Images';
import { t } from '../../../translation/translation';
import { Button } from '../../common/Button';
import SectionContainer from '../../common/SectionContainer';
import NavBar from '../../navigation/NavBar';
import './style.css'

export const MainHeader = () => {

    const isMobile = useIsMobile()

    return (
        <SectionContainer >
            <div className='main-header-container'>
                <NavBar />
                <div className='main-header-content-container'>
                    <div className='main-header-content-text'>
                        <h1>
                            {t('MAIN_HEADER_TITLE_PART_1')}{' '}
                            <span className="text-blue">{t('MAIN_HEADER_TITLE_PART_2')}</span>{' '}
                            {t('MAIN_HEADER_TITLE_PART_3')}
                        </h1>
                        <p>{t('MAIN_HEADER_SUBTITLE')}</p>
                        <div className='main-header-button-container'>
                            <Button
                                iconLeft={IMAGES_PATH.LOGO_APPLE}
                                label={t(TEXT_KEYS.APPLE_STORE)}
                            />
                            <Button
                                iconLeft={IMAGES_PATH.LOGO_ANDROID}
                                label={t(TEXT_KEYS.PLAY_STORE)}
                            />
                        </div>
                        {isMobile === true && (
                            <div className='main-header-content-phone-mobile'>
                                <img src={IMAGES_PATH.SCREEN_MAIN_HEADER} alt="Main Header Screen" />
                            </div>
                        )}
                    </div>
                    {isMobile === false ?
                        <div className='main-header-content-phone-placeholder'>
                            <div className='main-header-content-phone'>
                                <img src={IMAGES_PATH.SCREEN_MAIN_HEADER} alt="Main Header Screen" />
                            </div>
                        </div>
                        : null}
                </div>
            </div>
            {isMobile ?
                <div className='main-header-bottom-margin-mobile' />
                :
                <div className='main-header-bottom-margin' />
            }
        </SectionContainer>
    );
};